import {createReducer} from 'redux-act'

import {configuration as initialState} from '../../configuration'

const reducer = createReducer({}, initialState)

export default reducer
